export const FirebaseConfig = {
	"projectId": "compagnie-vtc-56",
	"appId": "1:714915390237:web:02ac886126c5408c77f7f4",
	"databaseURL": "https://compagnie-vtc-56-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "compagnie-vtc-56.firebasestorage.app",
	"apiKey": "AIzaSyCfSoZXKM6yM_E_gFuSv5U-4Onq11hVfRA",
	"authDomain": "compagnie-vtc-56.firebaseapp.com",
	"messagingSenderId": "714915390237",
	"measurementId": "G-TJ7ZXSTVEZ"
};